import { AppContext } from 'providers/AppContext';
import { useContext, useEffect, useState } from 'react';
import useSWR from 'swr';
import {
	buildNetbankPayload,
	getNetbankFormErrors,
	getNetbankFormValues,
	validators
} from './NetbankHelpers';

export function useNetbank() {
	const ctx = useContext(AppContext);
	const { config, goToNextPage, http, navigate, state, t } = ctx;
	const { context, user } = state;
	const { kennitala, processInfo } = context;
	const { agreementProcessId = '' } = processInfo || {};
	const [applicantIsOnlyUser, setApplicantIsOnlyUser] = useState(true);
	const [errors, setErrors] = useState<Record<string, string>>({});
	const { data } = useSWR(`${config.API.hasOnlineBankingAccount}?ssn=${kennitala}`);

	const validate = (e: React.FormEvent<HTMLInputElement>) => {
		e.preventDefault();
		e.stopPropagation();
		const newErrors = (validators as Record<string, (value: string) => Record<string, string>>)[
			e.currentTarget.name
		](e.currentTarget.value);
		const oldErrors = { ...errors };
		delete oldErrors[e.currentTarget.name];
		setErrors({ ...oldErrors, ...newErrors });
	};

	const submitForm = (e: unknown) => {
		if (e && 'preventDefault' in (e as React.FormEvent)) {
			(e as React.FormEvent).preventDefault();
			(e as React.FormEvent).stopPropagation();
		}
		if (applicantIsOnlyUser) {
			goToNextPage();
		} else {
			const values = getNetbankFormValues(applicantIsOnlyUser);
			const newErrors = getNetbankFormErrors(values);
			setErrors(newErrors);
			if (!Object.keys(newErrors).length) {
				const msg = t('submit_label', 'netbank');
				const payload = buildNetbankPayload(values, user.kennitala);
				http.post(`${config.API.netbank}/${agreementProcessId}`, payload, msg).then(goToNextPage);
			}
		}
	};

	useEffect(() => {
		if (data?.hasOnlineBankingAccount) {
			goToNextPage();
		}
	}, [data]); // eslint-disable-line react-hooks/exhaustive-deps

	return {
		...ctx,
		applicantIsOnlyUser,
		errors,
		goToNextPage,
		navigate,
		setApplicantIsOnlyUser,
		submitForm,
		validate
	};
}
